import APP_ACTIONS from '../constants/app-actions';
import localStorageAPI from '../services/local-storage-api';

import user from './user';
import placedOrder from './placed-order';
import UserAPI from '../apis/user';

const auth = {
    login: (accessResponse, locale) => (dispatch, getState) => {
        dispatch({
            type: APP_ACTIONS.LOGIN,
            payload: accessResponse,
        });
        dispatch(auth.checkAuthTimeout(accessResponse.expires_in));
        dispatch(placedOrder.clearPlacedOrder());

        UserAPI.getUser({ token: accessResponse.access_token, locale }).then((response) => {
            dispatch({
                type: APP_ACTIONS.USER,
                payload: {
                    id: response.body.data.id,
                    ...response.body.data.attributes,
                },
            });
            localStorageAPI.save(getState());
        });

        localStorageAPI.save(getState());
    },

    authCheckState: () => (dispatch, getState) => {
        if (getState().user.id) {
            UserAPI.refreshToken(getState().auth.refresh_token)
                .then((response) => {
                    dispatch({
                        type: APP_ACTIONS.LOGIN,
                        payload: {
                            ...response.body,
                        },
                    });
                    dispatch(auth.checkAuthTimeout(response.body.expires_in));
                    localStorageAPI.save(getState());
                })
                .catch((err) => {
                    console.log(err);
                    console.log(err.Error);
                    dispatch(user.logout());
                });
        }
    },

    checkAuthTimeout: (expirationTime) => (dispatch, getState) => {
        console.log(expirationTime);
        setTimeout(() => {
            dispatch(auth.authCheckState());
        }, expirationTime * 1000);
    },
};

export default auth;



/** WEBPACK FOOTER **
 ** ./src/actions/auth.js
 **/